import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockTransferLine, StockTransferLineCreate, StockTransferLineFilter } from '../data/stockTransferLine';

export function createStockTransferLineService(client: AxiosInstance) {
  return createCrudService<StockTransferLine, StockTransferLineCreate, StockTransferLineFilter>(
    client,
    '/purchase/StockTransferLine',
    'id',
  );
}

export type StockTransferLineService = CrudService<StockTransferLine, StockTransferLineCreate, StockTransferLineFilter>;
